module.exports = __webpack_public_path__ + "media/components/star-rating/static/white/6-8fc87132c08778ea632ba323a6743184.svg";